import { Box, Button, Heading, Img } from "@chakra-ui/react";
import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import banner from "../../assets/material-banner.svg";
import { useNavigate } from "react-router-dom";
import WatchDemoButton from "../../components/WatchDemoButton";

const Banner = () => {
  const nav = useNavigate();
  return (
    <>
      <div
        style={{
          backgroundImage: ` url(${banner})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          // fontFamily: "Satoshi"
          // backgroundColor: "black"
        }}
        className={"h-[70vh] rounded-lg w-full top-0 left-0 relative"}
      >
        <div className="absolute top-6 right-6 z-20">
          <WatchDemoButton
            videoUrl={
              "https://drive.google.com/file/d/1yMEG3awMB-34x4k8eswBy45AwcNbSpUr/preview"
            }
          />
        </div>

        <Box
          h={"100%"}
          display={"flex"}
          flexDir={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          color={"white"}
          gap="7"
          zIndex={10}
        >
          <Heading fontWeight={500} fontSize={"md"}>
            Best Interior Design Material
          </Heading>
          <Box
            display={"flex"}
            flexDir={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            color={"white"}
            gap="5"
          >
            <Heading fontWeight={700} fontSize={"56px"}>
              Welcome to AirBrick Material Library
            </Heading>

            <Heading fontWeight={500} fontSize={"xl"}>
              Where your imaginition fulfils with the materials
            </Heading>
            <div className="flex gap-4 items-center">
              <PrimaryButton
                onClick={() => nav("/material/material-filter?type=browse")}
              >
                Browse Library
              </PrimaryButton>
              <Button
                onClick={() => nav("/material/material-filter?type=select")}
              >
                Client Selection
              </Button>
            </div>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default Banner;
